module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "4danger.ec699758.svg";